'use client'

import { useUserPortfolio } from '@repo/services'
import {
  HistoryChanges,
  InputCurrency,
  PaymentType,
  TransactionsChart,
} from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Typography } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import { useMemo } from 'react'

export const BalanceAssetDetails = ({ assetId }: { assetId: string }) => {
  const { t } = useTranslate()
  const { data: { data: { accounts = [] } = {} } = {} } = useUserPortfolio()
  const isDesktop = useIsDesktop()
  const account = useMemo(() => {
    return accounts?.find((account) => account.currency === assetId)
  }, [accounts, assetId])

  const data = account

  const changes = [
    {
      label: t('common_change_24h'),
      value: data?.delta24H?.amount ?? 0,
      percent: data?.delta24H?.percent ?? 0,
    },
    {
      label: t('common_change_7d'),
      value: data?.delta7D?.amount ?? 0,
      percent: data?.delta7D?.percent ?? 0,
    },
    {
      label: t('common_change_30d'),
      value: data?.delta30D?.amount ?? 0,
      percent: data?.delta30D?.percent ?? 0,
    },
  ]

  return (
    <Card className='w-full mb-xs' withoutBorder={!isDesktop}>
      <Col className='gap-md text-neutral-surface-60 items-center'>
        <div className='flex flex-row justify-between w-full border-y border-neutral-surface-dark py-md md:py-0 md:border-none'>
          <Col className='items-center gap-xs'>
            <Typography size='2xs' className='text-center'>
              {t('walletPage_your_assets')}
            </Typography>
            <PaymentType
              value={data?.availableBalance}
              size='2xs'
              numberSize='sm'
              inputCurrency={data?.currency as InputCurrency}
            />
          </Col>
          <Col className='items-center gap-xs'>
            <Typography size='2xs' className='text-center'>
              {t('walletPage_your_assets_value')}
            </Typography>
            <PaymentType
              value={(data?.availableBalance ?? 0) * 1000}
              size='2xs'
              numberSize='sm'
            />
          </Col>
        </div>

        <div className='flex flex-col md:flex-row justify-between w-full gap-md'>
          <HistoryChanges changes={changes} />
          <TransactionsChart currency={data?.currency} />
        </div>
      </Col>
    </Card>
  )
}
